import { LOCAL_STORAGE } from './../constants/constant';
import * as numeral from "numeral";

export function AgGridFn(lists: Array<any>) {
    let arrAgGrids = [];
    for (let value of lists) {
        let row: any = null;
        if (value.isStatusLable) {
            row = {
                headerName: value.columnCaption,
                field: value.columnField,
                cellClass: value.cellClass,
                filter: value.isFilter ? 'agTextColumnFilter' : '',
                sortable: true,
                width: value.columnWidth,
                cellRenderer: (params: any) => {
                    return `<span class="noti-number noti-number-on ml5">${params.value}</span>`
                },
                hide: value.isHide ? true : false,
                pinned: value.pinned,
                headerTooltip: value.columnCaption,
                tooltipField: value.columnField
            }
        } else {
            if (value.columnField === 'avatarUrl' || value.fieldType === 'image') {
                row = {
                    headerName: value.columnCaption,
                    field: value.columnField,
                    // cellClass: value.cellClass,
                    filter: value.isFilter ? 'agTextColumnFilter' : '',
                    sortable: true,
                    width: value.columnWidth,
                    hide: value.isHide ? true : false,
                    pinned: value.pinned,
                    cellRenderer: "avatarRendererFull",
                    headerTooltip: value.columnCaption,
                    tooltipField: value.columnField,
                    cellClass: ['text-center', 'text-right', 'border-right', 'd-flex', 'align-items-center', 'justify-content-center'],
                    // valueFormatter: value.fieldType == 'decimal' ? ""
                }
            } else if (value.fieldType === 'check') {
                row = {
                    headerName: value.columnCaption,
                    field: value.columnField,
                    cellClass: value.cellClass,
                    filter: value.isFilter ? 'agTextColumnFilter' : '',
                    sortable: true,
                    width: value.columnWidth,
                    cellRenderer: (params: any) => {
                        return ` <span class="custom-control custom-checkbox float-left" style="margin-top: 7%;">
                        <input type="checkbox" ${params.value ? 'checked' : ''} disabled class="custom-control-input"  >
                        <label class="custom-control-label"></label>
                      </span>`;
                    },
                    hide: value.isHide ? true : false,
                    pinned: value.pinned,
                    headerTooltip: value.columnCaption,
                    // tooltipField: value.columnField
                    // valueFormatter: value.fieldType == 'decimal' ? "x.toLocaleString()" : ""
                }
            } else if (value.fieldType === 'text_congcu') {
                row = {
                    headerName: value.columnCaption,
                    field: value.columnField,
                    cellClass: value.cellClass,
                    filter: value.isFilter ? 'agTextColumnFilter' : '',
                    sortable: true,
                    width: value.columnWidth,
                    cellRenderer: (params: any) => {
                        return ` 
                        <label>${params.value}</label>
                      `;
                    },
                    hide: value.isHide ? true : false,
                    pinned: value.pinned,
                    headerTooltip: value.columnCaption,
                    tooltipField: value.columnField,
                    // tooltipField: value.columnField
                    // valueFormatter: value.fieldType == 'decimal' ? "x.toLocaleString()" : ""
                }
            }
             else if (value.fieldType === 'decimal') {
                row = {
                    headerName: value.columnCaption,
                    field: value.columnField,
                    cellClass: value.cellClass || [],
                    headerClass: value.headerClass,
                    cellStyle: value.cellStyle,
                    cellClassRules: value.conditionClass,
                    filter: value.isFilter ? 'agTextColumnFilter' : '',
                    sortable: true,
                    width: value.columnWidth,
                    cellRenderer: value.isMasterDetail ? 'agGroupCellRenderer' : '',
                    hide: value.isHide ? true : false,
                    pinned: value.pinned,
                    tooltipField: value.columnField,
                    headerTooltip: value.columnCaption,
                    valueFormatter: value.customFormat ? formatMargin : formatNumber2
                };
            } else {
                row = {
                    headerName: value.columnCaption,
                    field: value.columnField,
                    cellClass: value.cellClass,
                    filter: value.isFilter ? 'agTextColumnFilter' : '',
                    sortable: true,
                    width: value.columnWidth,
                    cellRenderer: value.isMasterDetail ? 'agGroupCellRenderer' : '',
                    hide: value.isHide ? true : false,
                    pinned: value.pinned,
                    tooltipField: value.columnField,
                    headerTooltip: value.columnCaption
                    // valueFormatter: value.fieldType == 'decimal' ? ""
                }
            }
        }

        arrAgGrids.push(row);
    }
    return arrAgGrids
}

export function stringtodate(datestring) {
    if (datestring) {
        const parts = datestring.split('/');
        const mydate = new Date(parts[2], parts[1] - 1, parts[0]);
        return mydate;
    } else {
        return new Date();
    }
}

export function formatNumber2(params) {
    const number = params.value;
    return numeral(number).format('0,0[.][000]')
}

export function formatMargin(params) {
    const numb = +params.value;
    return (numb * 100).toFixed(2);
}

export function ShowFullScreen() {
    const c: any = document.querySelector(".breadcrumb");
   // const d: any = document.querySelector(".filterInput");
    const e: any = document.querySelector(".paginator");
    const totalHeight = c.clientHeight  + e.clientHeight + 24;
    const main: any = document.querySelector(".main");
    main.className = main.className + ' grid-fixed';
    return window.innerHeight - totalHeight
}

export function HideFullScreen() {
    const main: any = document.querySelector(".main");
    main.className = 'main';
    const a: any = document.querySelector(".header");
    const b: any = document.querySelector(".sidebarBody");
    const c: any = document.querySelector(".breadcrumb");
    //const d: any = document.querySelector(".filterInput");
    const e: any = document.querySelector(".paginator");
    const totalHeight = a.clientHeight + b.clientHeight + c.clientHeight + e.clientHeight + 45;
    return window.innerHeight - totalHeight
}

export function CheckHideAction(path, action) {
    let assetsMenus: any = localStorage.getItem(LOCAL_STORAGE.ASSETS_MENU);
    if (assetsMenus) {
        assetsMenus = JSON.parse(assetsMenus)
        for(let menuIndex = 0; menuIndex < assetsMenus.length; menuIndex++) {
            const menu = assetsMenus[menuIndex];
            if (menu.url === path && menu.actions && menu.actions && menu.actions.includes(action)) {
                return true;
            }
            if (menu.items && menu.items.length) {
                for(let subIndex = 0; subIndex < menu.items.length; subIndex++) {
                    const childMenu = menu.items[subIndex];
                    let checkAction = null;
                    if (childMenu.actions && childMenu.actions) {
                        checkAction =  childMenu.actions.find(a => a.actionCd === action)
                    }
                    if (childMenu.url === path && checkAction) {
                        return true;
                    }
                }
            }
        }
    }
    return false;
}

export function CheckPermission(tree, url, actionCd) {
    // for (const child of tree) {
    //     if (child.path === url && child.actions.filter(t => t.check).map(t => t.actionCd).includes(actionCd))
    //         return true;
    //     if (child.items && child.items.length > 0) {
    //         if (CheckPermission(child.items, url, actionCd))
    //         return true;
    //     }
    // }
    return true;
}

export function getPermissionByMenu(url) {
    const menusActive = JSON.parse(localStorage.getItem(LOCAL_STORAGE.ASSETS_PERMISSION_MENU));
    for(let menu of menusActive) {
        if (menu.url === url) {
            return menu.actions;
        }
        if (menu.items && menu.items.length) {
            for(let child of menu.items) {
                if (child.url === url) {
                    return child.actions;
                }
            }
        }
    }
    return null;
}